export const REDUCER_NAME = "matchEvents";
export const SET_ERROR = `${REDUCER_NAME}/SET_ERROR`;
export const SET_MATCHEVENTS = `${REDUCER_NAME}/SET_MATCHEVENTS`;

export const getKey = (data) => `${data.matchId}`;
